export class CustomError extends Error {
    constructor(...params: ConstructorParameters<typeof Error>) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params);

        // Set the prototype explicitly to maintain instanceof checks
        // See https://www.dannyguo.com/blog/how-to-fix-instanceof-not-working-for-custom-errors-in-typescript/
        Object.setPrototypeOf(this, CustomError.prototype);

        // Maintains proper stack trace for where our error was thrown (only
        // available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CustomError);
        }

        this.name = "CustomError";
    }
}
